import { DateTime, DurationObjectUnits } from 'luxon';

import { Interval } from '../models/interval';

export class PhaseShiftHelper {
  public static toDuration(interval: Interval, shift: number): DurationObjectUnits {
    switch (interval) {
      case Interval.HOURS: {
        return { hours: shift };
      }
      case Interval.DAYS: {
        return { days: shift };
      }
      case Interval.MONTHS: {
        return { months: shift };
      }
      default: {
        return { minutes: shift };
      }
    }
  }

  public static shiftDate(date: DateTime, interval: Interval, shift: number): DateTime {
    return shift ? date.plus(PhaseShiftHelper.toDuration(interval, shift)) : date;
  }

  public static getSliceShift(interval: Interval, startDate: DateTime, endDate: DateTime): number {
    const half = PhaseShiftHelper.diff(interval, startDate, endDate) / 2;
    const step = interval === Interval.THREE_MINUTES ? 3 : 1;
    return Math.max(step, Math.round(half / step) * step);
  }

  public static fromCalendarDate(interval: Interval, referenceCalendarDate: DateTime, pickedDate: DateTime): number {
    let target: DateTime;
    switch (interval) {
      case Interval.HOURS: {
        target = pickedDate.set({ hour: referenceCalendarDate.hour, minute: referenceCalendarDate.minute });
        break;
      }
      case Interval.DAYS:
      case Interval.MONTHS: {
        target = pickedDate.set({
          day: referenceCalendarDate.day,
          hour: referenceCalendarDate.hour,
          minute: referenceCalendarDate.minute
        });
        break;
      }
      default: {
        target = pickedDate;
      }
    }
    const shift = Math.round(PhaseShiftHelper.diff(interval, referenceCalendarDate, target));
    return interval === Interval.THREE_MINUTES ? Math.round(shift / 3) * 3 : shift;
  }

  private static diff(interval: Interval, from: DateTime, to: DateTime): number {
    switch (interval) {
      case Interval.HOURS: {
        return to.diff(from, 'hours').hours;
      }
      case Interval.DAYS: {
        return to.diff(from, 'days').days;
      }
      case Interval.MONTHS: {
        return to.diff(from, 'months').months;
      }
      default: {
        return to.diff(from, 'minutes').minutes;
      }
    }
  }
}
